<div class="row message">
  <!-- Client only code -->
  <div class="container">
    <ngb-alert *ngIf="successMessage && clientOnlyRun" (click)="alertClicked()" type="success" (close)="alertClicked()">
      <i class="fa fa-check-circle fa-3x" aria-hidden="true"></i>
      {{ successMessage }}
      <button type="button" class="actionButton transparentButton" [routerLink]="['/compra/carrito']">VER TODOS</button>
    </ngb-alert>
    <ngb-alert *ngIf="successFavoritoMessage && clientOnlyRun" (click)="alertFavoritoClicked()" type="success" (close)="alertFavoritoClicked()">
      <i class="fa fa-check-circle fa-3x" aria-hidden="true"></i>
      {{ successFavoritoMessage }}
      <button type="button" class="actionButton transparentButton" [routerLink]="['/cuenta']" [queryParams]="{tab: '2'}">VER TODOS</button>
    </ngb-alert>
  </div>
</div>
<div class="container producto">
  <!-- Client only code -->
  <div class="producto__header" style="position: relative;" *ngIf="clientOnlyRun">
    <h1 [ngStyle]="{'max-width': producto.oferta == false && producto.novedad == false ? 'unset' : 'calc(100% - 60px)' }">{{producto["titulo"] + ', ' + producto["titulo"] + ' al por mayor'}}</h1>
  </div>
  <!-- Server only code -->
  <div class="producto__header" style="position: relative;" *ngIf="serverOnlyRun">
    <h1 style="max-width: unset;">{{ tituloProducto }}</h1>
  </div>
  <br>
  <div class="row">
    <div class="badges" style="z-index: 9;">
      <!-- Combo -->
      <div *ngIf="producto.kit == '1' && producto.descuentoKit > 0" style="z-index: 10;" class="oferta" [ngClass]="{'resultado__item__disabled': producto.enStock == '0' && producto.ventaSoloPorPedido == '0'}">
        <h3 class="badge">COMBO</h3>
      </div>
      <!-- Oferta -->
      <div *ngIf="producto.oferta == true" class="oferta" [ngClass]="{'resultado__item__disabled': producto.enStock == '0' && producto.ventaSoloPorPedido == '0'}">
        <h3 class="badge">OFERTA DEL MES</h3>
      </div>
      <!-- Novedades -->
      <div *ngIf="producto.novedad == true" class="imperdible" [ngClass]="{'resultado__item__disabled': producto.enStock == '0' && producto.ventaSoloPorPedido == '0'}">
        <h3 class="badge">NOVEDAD</h3>
      </div>
    </div>
    <!-- Client only code -->
    <div class="col-12 col-md-6 imagen__visor position-relative" style="display: flex;justify-content: center;" *ngIf="clientOnlyRun">
      <!-- Imagen unica -->
      <div class="zoom-container">
        <img *ngIf="!(producto.imagenes && producto.imagenes.length > 0) && !producto.youtubeId" width="450" height="300" style="max-width: 100%; height: max-content;" [ngClass]="'lazyload'" [attr.data-src]="producto['urlImagen']" onerror="this.src='/assets/images/producto/picGenerica.webp'" alt="Foto" (mousemove)="onImageMouseMove($event)">
      </div>
      <div *ngIf="(producto.imagenes && producto.imagenes.length > 0) || producto.youtubeId" class="w-100 d-flex flex-column gap-2 producto__carousel">
        <!-- SwiperJS -->
        <swiper-container
          #swipercarouselsinaproducto
          id="producto-swiper-imagenes"
          init="false"
          class="w-100"
        >
          <swiper-slide class="d-flex justify-content-center align-items-center" style="height: 93vw; max-height: 450px;">
            <div class="zoom-container">
              <img width="450" height="300" style="max-width: 100%; height: max-content;" [ngClass]="'lazyload'" [attr.data-src]="producto['urlImagen']" onerror="this.src='/assets/images/producto/picGenerica.webp'" alt="Foto" (mousemove)="onImageMouseMove($event)">
            </div>
          </swiper-slide>
          <swiper-slide *ngFor="let i of producto.imagenes" class="d-flex justify-content-center align-items-center" style="height: 93vw; max-height: 450px;">
            <div class="zoom-container">
              <img width="450" height="450" style="max-width: 100%; height: max-content;" [ngClass]="'lazyload'" [attr.data-src]="i.url_imagen" onerror="this.src='/assets/images/producto/picGenerica.webp'" alt="Foto" (mousemove)="onImageMouseMove($event)">
            </div>
          </swiper-slide>
          <swiper-slide *ngIf="producto.youtubeId">
            <iframe width="100%" height="450" [src]="'https://www.youtube.com/embed/'+producto.youtubeId | safeUrlProducto" title="Video - Producto Sina" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </swiper-slide>
        </swiper-container>
        <!-- ThumbsSwiperJS -->
        <swiper-container
          #swipercarouselsinaproductothumbnails
          id="producto-swiper-thumbnails"
          init="false"
          class="w-100"
        >
          <swiper-slide class="w-auto d-flex justify-content-center align-items-center">
            <img width="135" height="90" [ngClass]="'lazyload'" [attr.data-src]="producto['urlImagen']" onerror="this.src='/assets/images/producto/picGenerica.webp'" alt="Thumbnail">
          </swiper-slide>
          <swiper-slide *ngFor="let i of producto.imagenes" class="w-auto d-flex justify-content-center align-items-center">
            <img width="90" height="90" [ngClass]="'lazyload'" [attr.data-src]="i.url_imagen" onerror="this.src='/assets/images/producto/picGenerica.webp'" alt="Thumbnail">
          </swiper-slide>
          <swiper-slide *ngIf="producto.youtubeId">
            <img width="90" height="90" [ngClass]="'lazyload'" [attr.data-src]="'/assets/images/producto/video_thumbnail.webp'" onerror="this.src='/assets/images/producto/picGenerica.webp'" alt="Video thumbnail">
          </swiper-slide>
        </swiper-container>
      </div>
      <div *ngIf="producto.habilitado == '1' && producto.sustentable == '1'" class="productoSustentable">
        <img width="75" height="76" [ngClass]="'lazyload'" data-src="./assets/images/iconos/sustentable2.webp" alt="Sustentable">
      </div>
      <div *ngIf="producto.habilitado == '0' || (producto.enStock == '0' && producto.ventaSoloPorPedido == '0')" class="sinStock">
        <img width="75" height="41" [ngClass]="'lazyload'" data-src="./assets/images/iconos/sin-stock.webp" alt="Sin stock">
      </div>
      <div *ngIf="producto.habilitado == '1' && producto.ventaSoloPorPedido == '1'" class="porPedido">
        <img width="75" height="41" [ngClass]="'lazyload'" data-src="./assets/images/iconos/consultar-stock.webp" alt="Por pedido">
      </div>
    </div>
    <!-- Server only code -->
    <div class="col-12 col-md-6 imagen__visor" style="max-height: 300px; display: flex;" *ngIf="serverOnlyRun">
      <!-- Loading spinner -->
      <div class="spinner">
        <div class="dot1"></div>
        <div class="dot2"></div>
      </div>
    </div>
    <div class="col-12 col-md-6 producto__descripcion">
      <!-- Client only code -->
      <div class="title" *ngIf="clientOnlyRun">
        <p *ngIf="producto.nombreMostrar">{{ producto.nombreMostrar }}</p>
        <p *ngIf="!producto.nombreMostrar">{{ producto['titulo'] }} - {{ producto['tituloAdicional'] }}</p>
        <div class="social">
          <i [shareButton]="'facebook'" [url]="full_link" class="fa fa-facebook" aria-hidden="true"></i>
          <i [shareButton]="'twitter'"  [url]="full_link" class="fa fa-twitter"  aria-hidden="true"></i>
        </div>
      </div>
      <!-- Server only code -->
      <div class="title" *ngIf="serverOnlyRun">
        <p>Cargando...</p>
        <div class="social">
          <i [shareButton]="'facebook'" [url]="full_link" class="fa fa-facebook" aria-hidden="true"></i>
          <i [shareButton]="'twitter'"  [url]="full_link" class="fa fa-twitter"  aria-hidden="true"></i>
        </div>
      </div>
      <div class="row codigo">
        <p>Código: {{producto['codInterno']}}</p>
        <p style="margin-bottom: 0px;">Código de barras: {{producto['codBarra']}}</p>
        <p class="mb-0">Presentación: {{producto["unidadMedida"]}}</p>

        <p class="mb-0" *ngIf="producto['largo'] && producto['unidadLargo']">Largo: {{producto["largo"] + ' ' + producto["unidadLargo"]}}</p>
        <p class="mb-0" *ngIf="producto['alto'] && producto['unidadAlto']">Alto: {{producto["alto"] + ' ' + producto["unidadAlto"]}}</p>
        <p class="mb-0" *ngIf="producto['profundidad'] && producto['unidadProfundidad']">Profundidad: {{producto["profundidad"] + ' ' + producto["unidadProfundidad"]}}</p>
        <p class="mb-0" *ngIf="producto['peso'] && producto['unidadPeso']">Peso: {{producto["peso"] + ' ' + producto["unidadPeso"]}}</p>
        <p class="mb-0" *ngIf="producto['volumen'] && producto['unidadVolumen']">Volumen: {{producto["volumen"] + ' ' + producto["unidadVolumen"]}}</p>
        <p class="mb-0 mt-1" *ngIf="producto['largo'] || producto['alto'] || producto['profundidad'] || producto['peso'] || producto['volumen']" style="font-size:12px;">Medidas aproximadas</p>
        <a class="mt-2 mb-2" *ngIf="producto.linkFicha" style="color:#777" [href]="producto.linkFicha" target="_blank" rel="noopener noreferrer">Descargar Ficha Técnica</a>
      </div>
      <div *ngIf="config.switchComprasActivo" class="precio__container justify-content-start mx-2">
        <div class="row producto__precio gap-1 gap-lg-3" *ngIf="producto.precio">
          <!-- Descuento Oferta -->
          <div class="titled div-oferta text-danger" *ngIf="producto.oferta == true && producto.show_descuento && producto.descuento">
            <span class="span-oferta-rosa">{{ producto.descuento }}% OFF</span>
          </div>
          <!-- Descuento Combo -->
          <div class="titled div-oferta text-danger" *ngIf="producto.kit == '1' && producto.descuentoKit > 0">
            <span class="span-oferta-rosa">{{ producto.descuentoKit }}% OFF</span>
          </div>
          <div class="titled">
            <p class="m-0">${{ formatMoney(producto.precio) }}</p>
          </div>
          <div class="titled fw-light precio-oferta" *ngIf="producto.oferta == true && producto.precio_mostrado > 0 && producto.precio_base > 0 && producto.precio_base > producto.precio">
            <span class="m-0 mt-auto text-decoration-line-through">${{ formatMoney(producto.precio_base) }}</span>
          </div>
          <div class="titled fw-light precio-oferta" *ngIf="producto.oferta == false && producto.kit == '1' && producto.descuentoKit > 0">
            <span class="m-0 mt-auto text-decoration-line-through">${{ formatMoney(producto.precio_mostrado / ((100 - producto.descuentoKit) / 100)) }}</span>
          </div>
          <div class="precio__container__mobile" *ngIf="producto.precio && iva_usuario">
            <p>{{iva_usuario}}</p>
          </div>
        </div>
        <div class="row producto__precio gap-1 gap-lg-3" *ngIf="!producto.precio && producto.kit == '1' && producto.descuentoKit > 0">
          <div class="titled div-oferta text-danger">
            <span class="span-oferta-rosa">{{ producto.descuentoKit }}% OFF</span>
          </div>
        </div>
        <div style="position: relative;"class="row producto__cartel" *ngIf="producto.precio && iva_usuario">
          <p class="p-0">{{iva_usuario}}</p>
        </div>
      </div>
      <div *ngIf="config.switchComprasActivo" class="d-flex flex-md-wrap align-items-end gap-2 button">
        <div class="row producto__compra col-md-12 m-0 w-auto">
          <div class="cantidad p-0">
            <p style="margin-right: 10px; margin-bottom: 0;">Cantidad:</p>
            <input *ngIf="producto.cantPack === '1'" name="cantidad" aria-label="Cantidad" (keyup.enter)="enterCheck()" type="number" min="1" max="999999" [(ngModel)]="producto.cantidad" (keyup)="revisarCantidad($event)" [disabled]="producto.habilitado == '0' || (producto.enStock == '0' && producto.ventaSoloPorPedido == '0')">
            <select *ngIf="producto.cantPack !== '1'" name="cantidad" aria-label="Cantidad" [(ngModel)]="producto.cantidad" [disabled]="producto.habilitado == '0' || (producto.enStock == '0' && producto.ventaSoloPorPedido == '0')">
              <option *ngFor="let cant of arrayCants" [value]="cant">{{cant}}</option>
            </select>
          </div>
        </div>
        <div class="d-flex gap-2">
          <button class="agregar actionButton w-auto m-0" *ngIf="producto.habilitado == '1' && producto.comprado == false && (producto.enStock == '1' || producto.ventaSoloPorPedido == '1')" (click)="newMessage(producto)">AGREGAR AL CARRITO</button>
        </div>
        <button class="bloqButton w-auto m-0" *ngIf="producto.habilitado == '0' || (producto.comprado == false && producto.enStock == '0' && producto.ventaSoloPorPedido == '0')">SIN STOCK</button>
        <button class="agregar actionButton btn-outline-success w-auto m-0" *ngIf="producto.comprado == true" (click)="removeMessage(producto)">AGREGADO</button>
        <button class="whiteButton w-auto m-0" [title]="producto.favorito ? 'Eliminar de favoritos' : 'Agregar a favoritos'" [ngClass]="producto.favorito ? 'remove_from_favoritos' : 'add_to_favoritos'" (click)="toggleFavorito(producto)">
          <img class="favorito_badge" width="100" height="91" [ngClass]="'lazyload'" data-src="./assets/images/iconos/heart.webp" alt="Favorito">
        </button>
      </div>
      <div class="mb-0 mt-4" *ngIf="producto.kit == '1'">
        <h5>Contenido del kit</h5>
        <div class="kit-insumos" *ngFor="let insumo of producto.insumos" >
          <a class="" routerLink="{{ getFullLink(insumo) }}" *ngIf="insumo.codInterno">
            <img width="28"  [ngClass]="'lazyload'" [attr.data-src]="insumo.urlImagen" alt="">
            <p class="mb-0">[{{ insumo.codInterno }}] {{ insumo.titulo }} <strong>x{{ insumo.cantidad }}</strong></p>
          </a>
        </div>
      </div>
      <div *ngIf="producto.descripcion" class="producto__descripcion mt-4 ql-editor px-0 h-auto" [innerHTML]='producto.descripcion | safeHtmlProducto'></div>
    </div>
  </div>
  <div class="row producto__relacionados pt-3 px-3 justify-content-center">
    <div class="p-0">
      <h2 class="wiggle fs-1">Artículos relacionados</h2>
    </div>
    <!-- Client only code -->
    <div class="row resultado px-0" *ngIf="clientOnlyRun">
      <div class="resultado__item col-6 col-md-3" *ngFor="let item of relacionados | myfilter:{id: null}">
        <app-producto-item [item]="item" [relacionado]="true" [sesion]="loginStatus" [mensaje]="_success" [mensajeFavorito]="_successFavorito"></app-producto-item>
      </div>
    </div>
    <!-- Server only code -->
    <div class="row resultado px-0" *ngIf="serverOnlyRun">
      <div class="resultado__item col-6 col-md-3" *ngFor="let item of [0,1,2,3]">
        <!-- Loading spinner -->
        <div class="spinner">
          <div class="dot1"></div>
          <div class="dot2"></div>
        </div>
      </div>
    </div>
  </div>
</div>
